export default "__VITE_ASSET__D3FA_Mmu__"